import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c1f3414"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "box-box" }

import { ArrowRight } from "@element-plus/icons-vue";
import Income from "@/components/Finance/Income.vue";
import Account from "@/components/Finance/Account.vue";
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'FinanceView',
  setup(__props) {

const select = ref(true);
const route = useRoute();
const router = useRouter();
const setSelect = (state) => {
  router.push({ path: "/layout/finance", query: { state: state } });
  select.value = state;
};
onMounted(() => {
  setSelect(route.query.state === "true" || !route.query.state);
});

return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_breadcrumb, {
        "separator-icon": _unref(ArrowRight) as any
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_breadcrumb_item, { to: {path:'/layout/home'} as any }, {
            default: _withCtx(() => [
              _createTextVNode("首页")
            ]),
            _: 1
          }),
          _createVNode(_component_el_breadcrumb_item, null, {
            default: _withCtx(() => [
              _createTextVNode("财务结算")
            ]),
            _: 1
          }),
          _createVNode(_component_el_breadcrumb_item, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(select.value ? "本期收益" : "往期对账"), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["separator-icon"]),
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          type: select.value && 'primary',
          onClick: _cache[0] || (_cache[0] = ($event: any) => (setSelect(true)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("本周收益")
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_component_el_button, {
          type: !select.value && 'primary',
          onClick: _cache[1] || (_cache[1] = ($event: any) => (setSelect(false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("往期对账")
          ]),
          _: 1
        }, 8, ["type"])
      ])
    ]),
    (select.value)
      ? (_openBlock(), _createBlock(Income, { key: 0 }))
      : (_openBlock(), _createBlock(Account, { key: 1 }))
  ]))
}
}

})